import { useContext } from 'react';
import { FC, ReactNode } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import UserContext from 'src/contexts/UserContext';

interface UpgradingGuardProps {
  children?: ReactNode;
}

const UpgradingGuard: FC<UpgradingGuardProps> = ({ children }) => {
  const { isServerDown } = useContext(UserContext);

  if (!isServerDown) {
    return <Redirect to="/app" />;
  }

  return <>{children}</>;
};

UpgradingGuard.propTypes = {
  children: PropTypes.node,
};

export default UpgradingGuard;
